export default "__VITE_ASSET__CdH9aDh7__"